import { Link } from "react-router-dom";
import { ArrowRight, Wand2 } from "lucide-react";

export function DiagnosticBanner() {
  return (
    <section data-testid="home-diagnostic-banner" className="px-5 pt-10 md:px-10">
      <Link to="/diagnostic" data-testid="home-diagnostic-cta"
        className="group mx-auto flex max-w-6xl flex-col gap-4 rounded-sm border border-[var(--gold)]/50 bg-[var(--ink-2)] p-6 transition-colors duration-300 hover:border-[var(--gold)] sm:flex-row sm:items-center md:p-8">
        <Wand2 className="h-8 w-8 shrink-0 text-[var(--gold-soft)]" />
        <div className="flex-1">
          <p className="font-display text-2xl md:text-3xl">Quelle routine pour vous ? <span className="italic gold-text">Diagnostic gratuit en 1 minute</span></p>
          <p className="mt-1 text-sm text-[var(--parchment)]/85">Cheveux afro, chute, tempes, locks, barbe ou peau : répondez à 3 questions et recevez vos soins conseillés.</p>
        </div>
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--gold-soft)]">Commencer <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
      </Link>
    </section>
  );
}
